import type { FilterOption } from '../types';

/** Compara região selecionada com as opções retornadas pela API (case-insensitive, trim). */
export function regionValueMatchesOption(selected: string | undefined, options: FilterOption[]): boolean {
  if (!selected || !options.length) return false;
  const s = selected.trim().toLowerCase();
  return options.some(o => String(o.value).trim().toLowerCase() === s);
}
